import React, { useCallback, useLayoutEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import Animated from 'react-native-reanimated';
import { SettingsSection, Button, withAnimatedNavigationHeader, SCROLL_INDICATOR_INSETS, SettingsItemWithCheckBox, Spacer, rem, } from 'design-system';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import useFetch, { muteErrorAndResult } from 'hooks/useFetch';
import useColors from 'hooks/useColors';
import { useCommonInvestStyles } from './styles';
import { strings } from '../components/OnboardingTitle';
import useRecurringOrderConfirm from '../hooks/useRecurringOrderConfirm';
import { getOrderPreview, updateRecurringBuy } from '../actions';
const HolidayScreen = withAnimatedNavigationHeader(({ route, navigation, scrollHandler }) => {
    const colors = useColors();
    const { params } = route;
    const buyConfig = route.params?.buyConfig;
    const [, , requesting, fetch] = useFetch(muteErrorAndResult);
    const [beforeOrAfter, setBeforeOrAfter] = useState('BEFORE');
    const commonStyles = useCommonInvestStyles();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
        });
    }, [colors.text.primary, commonStyles.header]);
    const assetId = params && 'recurringBuy' in params ? params.recurringBuy.assetId : params?.assetId;
    const [confirmCallback] = useRecurringOrderConfirm(assetId);
    const handleHolidaySelect = useCallback((selection) => () => {
        setBeforeOrAfter(selection);
    }, []);
    const onSubmit = useCallback(async () => {
        if (params) {
            if ('recurringBuy' in params) {
                const response = await fetch(updateRecurringBuy(params.recurringBuy.id, {
                    buyConfig: params.buyConfig,
                    nonTradingDayPreference: beforeOrAfter,
                }));
                if (response?.recurringBuy) {
                    navigation.navigateDeprecated('RecurringBuy', {
                        recurringBuy: response.recurringBuy,
                    });
                }
            }
            else {
                const { amount } = params;
                const result = await fetch(getOrderPreview(amount, assetId, undefined, 'buy'));
                if (result?.order) {
                    confirmCallback(amount, buyConfig, beforeOrAfter, result.order.estimated.fxConversion, result.order.estimated.amount);
                }
            }
        }
    }, [assetId, beforeOrAfter, buyConfig, confirmCallback, params]);
    return (<View style={commonStyles.containerNoPadding}>
        <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} keyboardShouldPersistTaps="handled" scrollIndicatorInsets={SCROLL_INDICATOR_INSETS} contentContainerStyle={commonStyles.contentContainer}>
          <ScreenInfoHeader title={strings.Holidays.title} subTitle={strings.Holidays.subtitle}/>
          <Spacer h={8}/>
          <SettingsSection noMarginTop>
            <SettingsItemWithCheckBox title="Before" selected={beforeOrAfter === 'BEFORE'} onPress={handleHolidaySelect('BEFORE')} style={styles.button}/>
            <SettingsItemWithCheckBox title="After" selected={beforeOrAfter === 'AFTER'} onPress={handleHolidaySelect('AFTER')} style={styles.button}/>
          </SettingsSection>
        </Animated.ScrollView>
        <Button brand onPress={onSubmit} isFetching={requesting} style={commonStyles.button} title={params && 'recurringBuy' in params ? 'Update' : 'Continue'}/>
      </View>);
}, ({ colors }) => ({
    hideTitleOnScroll: true,
    title: strings.Holidays.shortTitle,
    headerColorOutputRange: [colors.background.dark, colors.cards.onDark],
}));
const styles = StyleSheet.create({
    button: {
        paddingVertical: rem(4),
    },
});
export default HolidayScreen;
